import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { LoadState } from "../../../../../../constants/enums";
import { fetchAutomobileAllApplicationsListAsync } from "../../../../../../redux/automobileApplication/automobileApplicationActions";
import { IAutomobileApplicationList } from "../../../../../../redux/automobileApplication/automobileApplication.types";

export const useAutomobileApplicationList = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
  const { list, loading } = useSelector(
    (storeState: IStoreState) =>
      storeState.automobile.allApplications.applicationsList
  );

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(
        fetchAutomobileAllApplicationsListAsync(customerPolicyId, "all_application", 1, 1000)
      );
    }
  }, [customerPolicyId]);

  const applicationDropdown = React.useMemo(() => {
    if (loading === LoadState.InProgress) {
      return [{ label: "Loading...", value: "" }];
    }
    const options = list.map((item: IAutomobileApplicationList) => ({
      label: String(item.incremental_number),
      value: String(item.incremental_number),
    }));
    return [{ label: "NONE", value: "" }, ...options];
  }, [list, loading]);

  const defaultApplicationNumber: string = React.useMemo(() => {
    if (list.length === 0) return "";
    const incrementalNumbers = list.map((item: IAutomobileApplicationList) => item.incremental_number);
    return String(Math.max(...incrementalNumbers));
  }, [list]);

  return { applicationDropdown, defaultApplicationNumber, loading };
};
